import { render, staticRenderFns } from "./MargemLucro.vue?vue&type=template&id=3450589e&scoped=true"
import script from "./MargemLucro.vue?vue&type=script&lang=js"
export * from "./MargemLucro.vue?vue&type=script&lang=js"
import style0 from "./MargemLucro.vue?vue&type=style&index=0&id=3450589e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3450589e",
  null
  
)

export default component.exports